@if (props.label) {
  <apm-section-title [title]="props.label" matTooltip="{{ canDebug ? field.key : '' }}"></apm-section-title>
}
<div>{{ field.defaultValue }}</div>
@if (props.image) {
  <div class="d-flex justify-content-center mt-3">
    <img src="{{ props.image }}" />
  </div>
}
<div class="mb-5"></div>
